import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from '../../i18n';
import { colors } from '../../theme/tokens';

interface LoadingProps {
  label?: string;
  minHeight?: number | string;
}

export function Loading({ label, minHeight = 240 }: LoadingProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        minHeight,
      }}
    >
      <CircularProgress sx={{ color: colors.primary }} />
      <Typography variant="body2" color="text.secondary">
        {label ?? t.common.loading}
      </Typography>
    </Box>
  );
}
